import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/waitPay/index'
import failPay from '@/components/failPay/index'
import successPay from '@/components/successPay/index'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '待付款'
      }
    },    {
      path: '/failPay',
      name: 'failPay',
      component: failPay,
      meta: {
        title: '已失效'
      }
    }, {
      path: '/successPay',
      name: 'successPay',
      component: successPay,
      meta: {
        title: '已付款'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js